/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Tenantid1Inputs */

const en_entity_tenantid1 = /** @type {(inputs: Entity_Tenantid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tenant ID`)
};

const de_entity_tenantid1 = /** @type {(inputs: Entity_Tenantid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mandanten-ID`)
};

/**
* | output |
* | --- |
* | "Tenant ID" |
*
* @param {Entity_Tenantid1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_tenantid1 = /** @type {((inputs?: Entity_Tenantid1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Tenantid1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_tenantid1(inputs)
	return de_entity_tenantid1(inputs)
});
export { entity_tenantid1 as "entity_tenantId" }